import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class FornecedoresService extends CommonService {

    getFornecedores(page, qntd, id_empresa) {
        let url = `fornecedores/fornecedor/${id_empresa}?_page=${page}&_pagesize=${qntd}`;
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                console.log(failed);
            })
    }


}


// WEBPACK FOOTER //
// ./src/domain/fornecedores/FornecedoresService.js